import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { FiltersItems } from '../types/rooms';

const initialState: any = {};

export type UpdateHotelFiltersType = {
  meals: Array<FiltersItems>;
  free_cancel: Array<FiltersItems>;
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    updateHotelFiltersAction: (
      _: any,
      action: PayloadAction<UpdateHotelFiltersType>,
    ) => action.payload,
  },
});

export const { updateHotelFiltersAction } = filtersSlice.actions;

const { name, reducer } = filtersSlice;
export { reducer as default, name };
